<template>
  <div class="about">
    <h1>Hello cloudflare workers</h1>
  </div>
</template>